import React from "react";
import "./TableInfoHeader.scss";
import classNames from 'classnames';

import TableInfoCell from "components/uiComponents/TableInfoCell";
import IndeterminateCheckbox from "components/uiComponents/IndeterminateCheckbox";

import { ReactComponent as ArrowSortIcon } from "static/icons/arrow-sort.svg";

const TableInfoHeader = ({
  header,
  onChangeCheckbox,
  status,
  sorting,
  onSortChange,
}) => {
  const headerUpd = header?.map(item => {
    return {
      name: item,
      label: item.split('(')[0].trim(),
    }
  });
  const [col1, ...rest] = headerUpd ? headerUpd : [];

  const handleSortClick = (name) => {
    if (typeof name === 'string') {
      onSortChange(name);
    } else {
      onSortChange(col1.name);
    }
  };

  return (
    <div className="table-info-header">
      <div className="table-info-header__row">
        <TableInfoCell>
          <div className="table-info-header__cell_content">
            <IndeterminateCheckbox
              onChange={onChangeCheckbox}
              status={status}
            />

            <div
              onClick={handleSortClick}
              className="table-info-header__cell_sort-wrapper"
            >
              <div className={classNames({
                "table-info-header__cell_title": true,
                "table-info-header__cell_title--active": sorting?.[col1.name]?.isActive,
              })}              
              >
                {col1.label}
              </div>

              <div className="table-info-header__sort">
                <ArrowSortIcon
                  className={classNames({
                    'table-info-header__sort-icon': true,
                    'table-info-header__sort-icon--active': sorting?.[col1.name]?.isActive,
                    'table-info-header__sort-icon--asc': !sorting?.[col1.name]?.isDescending,
                  })}
                />
              </div>
            </div>
          </div>
        </TableInfoCell>

        {rest.map((el, index) => {
          const handleInsideSortClick = () => {
            handleSortClick(el.name);
          };

          return (
            <TableInfoCell key={`tableheader${el.name}`}>
              <div className="table-info-header__cell_content">
                <div
                  onClick={handleInsideSortClick}
                  className="table-info-header__cell_sort-wrapper"
                >
                  <div 
                    className={classNames({
                      "table-info-header__cell_title": true,
                      "table-info-header__cell_title--active": sorting?.[el.name]?.isActive,
                    })}
                  >
                    {el.label}
                  </div>

                  <div className="table-info-header__sort">
                    <ArrowSortIcon
                      className={classNames({
                        'table-info-header__sort-icon': true,
                        'table-info-header__sort-icon--active': sorting?.[el.name]?.isActive,
                        'table-info-header__sort-icon--asc': !sorting?.[el.name]?.isDescending,
                      })}
                    />
                  </div>
                </div>
              </div>
            </TableInfoCell>
          )
        })}
      </div>
    </div>
  );
};

export default TableInfoHeader;
